module.exports = __webpack_public_path__ + "img/9788967352318.ee288615.jpg";